import React, { useEffect } from "react";
import {
	IonGrid,
	IonRow,
	IonCol,
	IonText,
	IonButton,
	IonImg,
	IonLabel,
	isPlatform,
} from "@ionic/react";

import "./offers.scss";
import * as constants from "../../../constants";
import moment from "moment";
import { checkMediaQuery } from "../../../utils";

const OfferDetails: React.FC = (props: any) => {
	const { location = {} } = props;
	const { state = {} } = location;
	const { offerDetails, isExpired = false } = state;

	console.log("offerDetails.displayColor .... ", offerDetails.displayColor);

	return (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			{isPlatform("ios") && <div className="ios_statusbar_color" />}
			<div className="personal_details_text offers_header mb-0 paddingBtm0">
				<div
					className="personal_details_div_child wholeApp offersFixedHeader"
					style={{
						paddingTop: isPlatform("android") ? 20 : 0,
					}}
				>
					<IonImg
						src={
							checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"
						}
						className="back_arrow"
						onClick={() => props.history.goBack()}
					/>
					<IonLabel className="personal_details_labels" color="secondary">
						{constants.OFFERS_DETAILS}
					</IonLabel>
					<div />
				</div>
			</div>
			<div className="newly_added off_marginTop90">
				<IonLabel>{constants.OFFERS}</IonLabel>
			</div>
			<div
				className="offer_layout"
				style={{
					//   background: `linear-gradient(93.91deg, ${offerDetails.displayColor} 1.09%, #231b05 64.95%)`,
					background: isExpired
						? "#999999" //: "#ff0000",
						: `linear-gradient(93.91deg, ${offerDetails.displayColor} 1.09%, #231b05 64.95%)`,
				}}
			>
				<IonRow className="discount_row">
					{!!offerDetails.name && (
						<>
							<IonCol className="vocher_code expired_offer" size-md="6" size="7">
								<div
									className="discount_div"
									style={{
										width: "100%",
									}}
								>
									<div className="discount_div discount_web offer_web">
										{offerDetails.name.split(" ").map((name: any, index: any) => (
											<IonLabel
												className={index === 1 ? "discount_value" : "discount_percentage"}
												key={index}
											>
												{index === 2 ? "Discount" : name}
											</IonLabel>
										))}
									</div>
								</div>
								<div
									className="refer-and-earn expired_border "
									style={{
										background: !isExpired ? "rgba(255, 255, 255, 0.2)" : "#2c252e",
									}}
								>
									<IonLabel className="year use_code">
										{constants.USE_CODE}
										<span className="offer_flat_code">{offerDetails.offerCode}</span>
									</IonLabel>
								</div>
								<IonLabel className="discount_date">
									{constants.VALID}
									<span className="date">
										{moment(offerDetails.validity.endDate).format("DD MMM YYYY")}
									</span>
								</IonLabel>
							</IonCol>
							<IonCol className="image_panel" size-md="6" size="5">
								<div className="img_scroll">
									<IonImg
										// src="/images/offer_icon.svg"
										src={offerDetails.imageUrl}
										className="discount_slides"
									/>
								</div>
							</IonCol>
						</>
					)}

					{!offerDetails.name && (
						<IonCol className="image_panel" size-md="6" size="5">
							<div className="img_scroll">
								<IonImg src={offerDetails.imageUrl} />
							</div>
						</IonCol>
					)}
				</IonRow>
			</div>
			<div className="terms_and_conditions">
				<IonLabel className="term_conditions_text">
					{constants.TERMS_AND_CONDITIONS}
				</IonLabel>
				{offerDetails.termsAndConditions.map((tc: any, ind: any) => (
					<IonLabel className="terms">{`${ind + 1}. ${tc}`}</IonLabel>
				))}
				{/* <IonLabel className="terms">{constants.TERMS_CONDTIONS_ONE}</IonLabel>
        <IonLabel className="terms">{constants.TERMS_CONDTIONS_TWO}</IonLabel>
        <IonLabel className="terms">
          {" "}
          {constants.TERMS_CONDTIONS_THREE}{" "}
        </IonLabel>
        <IonLabel className="terms">{constants.TERMS_CONDTIONS_FOUR}</IonLabel> */}
			</div>
		</IonCol>
	);
};

export default OfferDetails;